import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import { useScrollTop } from "../hook/useScrollTop";
import privacyPloicyImg from "../images/privacy-policy.jpg";

const PrivacyAndPolicy = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Privacy And Policy</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={privacyPloicyImg}>
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size">
            Privacy and Policy
          </h1>
        </div>
      </Header>
      <section className="container-fluid">
        <section className="ms-47 me-47 pt-7 pb-7 text-align-justify fs-16">
          <div>
            <h2 className="fs-18 gilroy-bold">Introduction</h2>
            <p>
              This website (“Site”) is controlled and operated by AFRO Group,
              Ltd. (referred to in this Privacy Policy as "AFRO Group", "we",
              "us" or "our"). This Privacy Policy ("Policy") explains what
              personal information is collected and recorded about you during
              your visit to this Site, including via cookies, and what we do
              with that information. It includes a description of your data
              protection rights, including a right to object to some of the
              processing which we carry out. Please read this Policy carefully.
            </p>
            <p>
              For the purposes of this Policy, “Group Company” means AFRO Group,
              Ltd. and its subsidiaries and affiliates.
            </p>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">Information we collect</h2>
            <p>
              We collect, receive, store and process the following information
              about you:
            </p>
            <ul>
              <li>
                your name, address and email address when you fill out a form on
                the Site;
              </li>
              <li>emails and any correspondence between you and us;</li>
              <li>your Internet Protocol (IP) address;</li>
              <li>operating system and browser type;</li>
              <li>date and time that you visited the Site;</li>
              <li>referral source;</li>
              <li>length of visit to the Site;</li>
              <li>the pages you view;</li>
              <li>website navigation paths; and,</li>
              <li>
                information as set out in the 'Cookies and similar technologies'
                section below.
              </li>
            </ul>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">Use of your information</h2>
            <p>
              We will use your personal information for the following purposes:
            </p>
            <ul>
              <li>to administer our Site and business;</li>
              <li>to communicate with you about the Site;</li>
              <li>
                for internal research and analysis so that we can see how our
                Site is being used and understand how we can improve our Site;
              </li>
              <li>
                to deal with enquiries and complaints made by or about you
                relating to us or our Site;
              </li>
              <li>to keep our Site and systems secure and prevent fraud;</li>
              <li>
                where relevant, to meet legal, regulatory and compliance
                requirements;
              </li>
              <li>
                where relevant, for the establishment, exercise or defence of
                legal claims;
              </li>
              <li>
                to protect the rights, property, or safety of us, our Group
                Companies, our customers, or others.
              </li>
            </ul>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">Sharing your information</h2>
            <p>
              We will disclose or transfer personal information to other parties
              as follows:
            </p>
            <ul>
              <li>
                to any Group Company for the purposes identified in this Policy
                (a list of local Group Company entities and their locations can
                be found at the end of this Policy);
              </li>
              <li>
                to third party service providers that perform functions on our
                behalf in relation to the Site and the purposes set out in this
                Policy (for example, website hosting and data analysts /website
                developers);
              </li>
              <li>
                if we are under a duty to disclose or share your personal
                information in order to comply with any legal obligation, or in
                order to enforce or apply our terms and conditions or other
                agreements or to protect the rights, property, or safety of us,
                any Group Company, our customers, or others;
              </li>
              <li>
                to government authorities, and to other third parties when
                compelled to do so by government and law enforcement authorities
                or otherwise as required or permitted by law, including but not
                limited to in response to court orders and subpoenas. We also
                disclose user information when we have reason to believe that
                someone is causing injury to or interference with our rights or
                property, other users of our site, or anyone else that could be
                harmed by such activities. Additionally, we cooperate with law
                enforcement inquiries and other third parties to enforce laws,
                intellectual property rights and other rights; and
              </li>
              <li>
                to prospective sellers or buyers as part of a sale or merger of
                our business or assets.
              </li>
            </ul>
            <p>
              AFRO Group will not sell the personal information that it collects
              from you.
            </p>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">
              Cookies and similar technologies
            </h2>
            <p>
              We are committed to ensuring that your privacy is protected. We
              aim to be as open and transparent as possible around the
              information we collect when you visit our Site, including through
              the use of "cookies".
            </p>
            <p>
              This section explains what cookies are and how we use them. It
              also explains the different types of cookies we use, and how you
              can change or delete them. We hope that this helps you understand
              and feel more confident about our use of cookies. If you have any
              further queries, please contact us at{" "}
              <a href="mailto:info@afro-group.com">info@afro-group.com</a> or
              alternatively you may contact the Director of Corporate Services
              at <a href="mailto: info@afro-group.com"> info@afro-group.com</a>
            </p>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">What are Cookies?</h2>
            <p>
              Cookies are small pieces of information sent by a web server to a
              web browser which allows the server to uniquely identify the
              browser on each page.
            </p>
            <p>
              We also use other tracking technologies, which are similar to
              cookies. This can include pixel tags and tracking URLs. All these
              technologies are together referred to in this Cookie Policy as
              “Cookies”.
            </p>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">How do we use Cookies?</h2>
            <p>
              The types of Cookies that we use on our Site, and the purposes for
              which they are used, are set out below. Note that the Cookies we
              use are subject to change and that we endeavour to keep our Cookie
              list up to date.
            </p>
            <ul>
              <li>
                <strong>Strictly necessary cookies:</strong> These cookies are
                essential in order to enable you to move around our Site and use
                its features, such as accessing secure areas of our Site.
                Without these cookies, any services on our Site you wish to
                access cannot be provided.
              </li>
              <li>
                <strong>Analytical/performance cookies:</strong> These cookies
                collect information about how you and other visitors use our
                Site, for instance which pages you go to most often, and if you
                get error messages from web pages. We use data from these
                cookies to help test designs and to ensure a consistent look and
                feel is maintained on your visit to the Site. All information
                these cookies collect is aggregated. It is only used to improve
                how a website works.
              </li>
            </ul>
            <p>
              We use Google Analytics, for example, to anonymously track website
              usage and activity. Google Analytics is a web analytics service
              provided by Google, Inc. (“Google”). Google Analytics uses
              “cookies”, which are text files placed on your computer, to help
              the website analyse how users use the site. The information
              generated by the cookie about your use of the website (including
              your IP address) will be transmitted to and stored by Google on
              servers in the United States. In case of activation of the IP
              anonymization, Google will truncate/anonymize the last octet of
              the IP address for Member States of the European Union as well as
              for other parties to the Agreement on the European Economic Area.
              Only in exceptional cases, the full IP address is sent to and
              shortened by Google servers in the USA. On behalf of the website
              provider Google will use this information for the purpose of
              evaluating your use of the website, compiling reports on website
              activity for website operators and providing other services
              relating to website activity and internet usage to the website
              provider. Google will not associate your IP address with any other
              data held by Google. You may refuse the use of cookies by
              selecting the appropriate settings on your browser. However,
              please note that if you do this, you may not be able to use the
              full functionality of this website. Furthermore you can prevent
              Google’s collection and use of data (cookies and IP address) by
              downloading and installing the browser plug-in available under
              https://tools.google.com/dlpage/gaoptout?hl=en-GB.
            </p>
            <p>
              We use Google Analytics, for example, to anonymously track website
              usage and activity. Google Analytics is a web analytics service
              provided by Google, Inc. (“Google”). Google Analytics uses
              “cookies”, which are text files placed on your computer, to help
              the website analyse how users use the site. The information
              generated by the cookie about your use of the website (including
              your IP address) will be transmitted to and stored by Google on
              servers in the United States. In case of activation of the IP
              anonymization, Google will truncate/anonymize the last octet of
              the IP address for Member States of the European Union as well as
              for other parties to the Agreement on the European Economic Area.
              Only in exceptional cases, the full IP address is sent to and
              shortened by Google servers in the USA. On behalf of the website
              provider Google will use this information for the purpose of
              evaluating your use of the website, compiling reports on website
              activity for website operators and providing other services
              relating to website activity and internet usage to the website
              provider. Google will not associate your IP address with any other
              data held by Google. You may refuse the use of cookies by
              selecting the appropriate settings on your browser. However,
              please note that if you do this, you may not be able to use the
              full functionality of this website. Furthermore you can prevent
              Google’s collection and use of data (cookies and IP address) by
              downloading and installing the browser plug-in available under
            </p>
            <p>
              You can refuse the use of Google Analytics by clicking on the
              following link. An opt-out cookie will be set on the computer,
              which prevents the future collection of your data when visiting
              this Site.
            </p>
            <p>
              Further information concerning the terms and conditions of use and
              data privacy can be found at
              http://www.google.com/analytics/terms/gb.html or at
              https://www.google.de/intl/en_uk/policies/. Please note that on
              this website, Google Analytics code is supplemented by
              “anonymizeIp” to ensure an anonymized collection of IP addresses
              (so called IP-masking).
            </p>
            <ul>
              <li>
                <strong>Marketing/targeting cookies:</strong> These cookies are
                used by these third parties to improve the relevancy of
                advertising campaigns.
              </li>
              <li>
                <strong>Pixel tags:</strong> Also known as a clear GIF or web
                beacon. These are invisible tags placed on certain pages of our
                Site but not on your computer. When you access these pages,
                pixel tags generate a generic notice of that visit. They usually
                work in conjunction with cookies, registering when a particular
                device visits a particular page. If you turn off cookies, the
                pixel tag will simply detect an anonymous website visit.
              </li>
              <li>
                <strong>Tracking URLs:</strong> These are used to determine from
                which referring website the Site is accessed.
              </li>
            </ul>
            <p>
              We require your consent for the use of some Cookies. You can give
              your consent either by closing the cookie banner displayed on the
              landing page of our website or by browsing the Site outside the
              cookie banner and clicking on any of the items on the Site. Please
              note that we track your consent using a technical Cookie;
              therefore, in the event you delete any Cookies stored on your
              devices you will see the Cookie banner once again.
            </p>
            <p>
              If you do not want to allow Cookies at all, or only want to allow
              use of certain Cookies, please refer to your browser settings. You
              can also use your browser settings to withdraw your consent to our
              use of Cookies at any time and delete Cookies that have already
              been set. Please note that by deleting our cookies or disabling
              future Cookies you may not be able to access certain areas or
              features of our Site.
            </p>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">
              {" "}
              Storage of personal information
            </h2>
            <p>
              AFRO Group will keep your personal information for as long as it
              needs it to provide AFRO Group' products and/or services to you
              and in accordance with its Data Retention and Deletion Policy.
              AFRO Group will try to keep personal information that it holds
              about you up to date, but if you think that AFRO Group is holding
              information which is inaccurate or you are otherwise unhappy about
              AFRO Group' use of your personal information, then please contact
              us using the details below.
            </p>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">Security</h2>
            <p>
              We take reasonable steps to protect your personal information as
              you visit and use the Site and to protect such information from
              loss, misuse, unauthorised access, disclosure, alteration or
              destruction. Unfortunately no data transmission can be guaranteed
              to be 100% secure. As a result we cannot warrant the security of
              any information you provide to us and you do so at your own risk.
            </p>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">Transfers</h2>
            <p>
              You understand and acknowledge that by using this Site, we collect
              and use personal information in the UK. We transfer personal
              information to countries outside the European Economic Area
              (“EEA”) to our Group Companies and to third parties, including to
              countries which have different data protection standards to those
              which apply in the EEA. Our Group Company locations are set out in
              the 'Our Group Companies' section below. Our service providers
              include locations in the EEA and Africa.
            </p>
            <p>
              Where service providers process your personal information in
              countries deemed adequate by the European Commission, we rely on
              the European Commission's decision to protect your personal
              information.
            </p>
            <p>
              For transfers to Group Companies and service providers outside the
              EEA, we use standard contractual clauses or rely on a service
              provider's Privacy Shield certification or a service provider's
              (EU data protection authority approved) corporate rules that are
              in place to protect your personal information. You have a right to
              ask us for a copy of the standard contractual clauses or a copy of
              the other methods used (by contacting us as set out below).
            </p>
          </div>
          <div>
            <h2 className="fs-18 gilroy-bold">Legal basis for processing</h2>
            <p>
              We process your personal information with your consent when you
              agree that we may place Cookies or on other occasions where we ask
              you for consent, for the purpose which we explain at that time.
              Where we do process personal information based on consent, your
              consent is revocable at any time (without affecting the lawfulness
              of processing based on consent before its withdrawal).
            </p>
            <p>
              We process your personal information when we are required to do
              this by law, including in response to requests by government or
              law enforcement authorities conducting an investigation or court
              orders.
            </p>
            <p>
              We process your personal information when it is necessary for the
              performance of a contract to which you are the party or in order
              to take steps at your request prior to entering into a contract.
              This applies in any case where we provide or deliver products and
              services to you pursuant to a contract, such as those related to
              telecommunications tower construction, tower maintenance and
              service operations. If you do not provide the personal information
              that we need in order to provide or deliver the service, we will
              not be able to provide or deliver services to you.
            </p>
            <p>
              We also process your personal information when it is necessary for
              the purposes of a legitimate interest pursued by us or a third
              party (when these interests are not overridden by your data
              protection rights).
            </p>
          </div>
          {/* your right */}
          <div>
            <h2 className="fs-18 gilroy-bold">Your rights</h2>
            <p>
              You may ask us for a copy of your information and, where
              applicable, to correct it, erase it or to transfer it to other
              organisations at your request. You also have rights to object to
              some processing and, where we have asked for your consent to
              process your personal information, to withdraw this consent. Where
              we process your personal information because we have a legitimate
              interest in doing so (as explained above), you also have a right
              to object to this. These rights may be limited in some situations
              – for example, where we can demonstrate that we have a legal
              requirement to process your personal information.
            </p>
            <p>
              We hope that we can satisfy queries you may have about the way we
              process your personal information. However, if you have unresolved
              concerns you also have the right to complain to data protection
              authorities. You can bring the complaint in your member state of
              residence, place of work or where an alleged infringement of data
              protection law occurred.
            </p>
            <p>
              To protect your privacy and security we will take reasonable steps
              to verify your identity when dealing with requests.
            </p>
          </div>
          {/* Changes to Privacy Policy
           */}
          <div>
            <h2 className="fs-18 gilroy-bold">Changes to Privacy Policy</h2>
            <p>
              AFRO Group may change this Privacy Policy from time to time. AFRO
              Group will post a notification on the Site if it has made
              significant changes to the policy. You should review this Policy
              frequently.
            </p>
          </div>
          {/* contact */}
          <div>
            <h2 className="fs-18 gilroy-bold">Contact</h2>
            <p>
              If you have any queries, comments or requests in relation to your
              personal information or this Policy, you can email{" "}
              <a href="mailto:info@afro-group.com">info@afro-group.com</a>
            </p>
            <p>Director of Corporate Services</p>
            <p>(18/1/4) Farrag Mall</p>
            <p>Central Axis, 2nd District</p>
            <p>6th October, Giza</p>
            <p>Egypt</p>
          </div>
        </section>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyAndPolicy;
